import { required, numeric } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';

import { shallowRef, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseForm from 'presentation/components/BaseForm/BaseForm.vue';
import BaseInput from 'presentation/components/BaseInput/BaseInput.vue';
import ServerError from 'presentation/components/ServerError/ServerError.vue';
import useCartTools from 'hooks/useCartTools';
import Toast from 'presentation/components/Toast/Toast.vue';
function Rules() {
  this.quantity = { required, numeric };
}

export default {
  name: 'AddToCartForm',
  props: {
    sku: {
      type: String,
      required: true,
    },
    isOnStock: {
      type: Boolean,
      required: true,
    },
    availableQuantity: {
      type: Number,
      required: false,
    },
    addCaption: {
      type: String,
      default: 'addToCart',
    },
  },
  components: {
    BaseForm,
    ServerError,
    BaseInput,
    Toast
  },
  setup(props) {
    const { t } = useI18n();
    const form = ref({ quantity: 1 });
    const rules = new Rules(form);
    const v = useVuelidate(rules, form);
    const showQuantityError = shallowRef(false);
    const { addLine } = useCartTools();
    const toastMessage = shallowRef(null);
    const toastType = shallowRef(null);
    const setToast = (message, type) => {
      if(message){
        toastMessage.value = message;
        toastType.value = type;

        setTimeout(()=>{
          toastMessage.value = null;
          toastType.value = null;
        }, 3000);
      }
    }
    const addLineItem = () =>
      addLine(props.sku, Number(form.value.quantity))
      .then(()=>setToast("Item Added To cart", 'success'))
      .catch((err)=>{
        console.error(err);
        setToast("Something went wrong", 'error')
      })
    return { t, addLineItem, v, showQuantityError, toastMessage, toastType };
  },
};
